var version = {
    "name":      "dativery",
    "buildDateCode": "20260415-101923",
    "buildDate": "Wed Apr 15 2026 10:19:23 GMT+0000 (Coordinated Universal Time)",
    "version":   "2.2.0",
    "uiVersion": "2.2.0-20260415-101923",
    "backupUIVersion": "2.2.0-20250519-102244"
}
;
 export default version;